(function () {
  'use strict';

  function formatMoney(rm) {
    return 'RM' + rm;
  }

  function trackAddToCart(pkg) {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'SPIRO+ ' + pkg.name,
        content_ids: [pkg.variantId],
        content_type: 'product',
        value: Number(pkg.price),
        currency: 'MYR',
      });
    }
  }

  function showToast(name) {
    var toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    var nameEl = toast.querySelector('[data-cart-toast-name]');
    if (nameEl) nameEl.textContent = 'Added to cart: ' + name;
    toast.hidden = false;
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 250);
    }, 4000);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  function addToCart(variantId, quantity) {
    if (!variantId) {
      console.error('SPIRO+ theme: no variant ID set on this package block. Add one in the theme customizer.');
      alert('This package is not linked to a Shopify product yet. Please contact support.');
      return Promise.reject(new Error('missing variant id'));
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Cart error'); });
      return r.json();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var heroSection = document.querySelector('[data-sticky-anchor="hero"]');
    var stickyBar = document.querySelector('[data-sticky-bar]');
    var packagePicker = document.querySelector('[data-package-picker]');

    var state = { variantId: null, name: null, price: null };

    function selectPackage(card) {
      document.querySelectorAll('[data-package-card]').forEach(function (c) {
        c.classList.toggle('is-selected', c === card);
      });
      state.variantId = card.getAttribute('data-variant-id');
      state.name = card.getAttribute('data-name');
      state.price = card.getAttribute('data-price');
      syncStickyBar();
    }

    function syncStickyBar() {
      if (!stickyBar) return;
      var label = stickyBar.querySelector('[data-sticky-current-label]');
      var price = stickyBar.querySelector('[data-sticky-current-price]');
      var addPrice = stickyBar.querySelector('[data-sticky-add-price]');
      if (label) label.textContent = state.name;
      if (price) price.textContent = formatMoney(state.price);
      if (addPrice) addPrice.textContent = state.price;
    }

    // Initial selection: block marked most_popular, else first
    var initial = document.querySelector('[data-package-card].is-selected') || document.querySelector('[data-package-card]');
    if (initial) selectPackage(initial);

    if (packagePicker) {
      packagePicker.addEventListener('click', function (e) {
        var card = e.target.closest('[data-package-card]');
        if (card) selectPackage(card);
      });
    }

    // Gallery
    var galleryRoot = document.querySelector('[data-gallery]');
    if (galleryRoot) {
      galleryRoot.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-gallery-thumb]');
        if (!thumb) return;
        var index = thumb.getAttribute('data-index');
        galleryRoot.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
        galleryRoot.querySelectorAll('[data-gallery-image]').forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-index') === index);
        });
      });
    }

    // Sticky bar visibility via IntersectionObserver on hero
    if (heroSection && stickyBar && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', show);
        },
        { threshold: 0, rootMargin: '0px 0px -80% 0px' }
      );
      observer.observe(heroSection);
    }

    // Sticky bar dropdown
    var dropdown = document.querySelector('[data-sticky-dropdown]');
    if (dropdown) {
      var toggle = dropdown.querySelector('[data-sticky-dropdown-toggle]');
      var menu = dropdown.querySelector('[data-sticky-dropdown-menu]');
      toggle.addEventListener('click', function () {
        menu.hidden = !menu.hidden;
      });
      menu.addEventListener('click', function (e) {
        var option = e.target.closest('[data-sticky-option]');
        if (!option) return;
        state.variantId = option.getAttribute('data-variant-id');
        state.name = option.getAttribute('data-name');
        state.price = option.getAttribute('data-price');
        syncStickyBar();
        var matchingCard = document.querySelector('[data-package-card][data-variant-id="' + state.variantId + '"]');
        if (matchingCard) selectPackage(matchingCard);
        menu.hidden = true;
      });
      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) menu.hidden = true;
      });
    }

    // Add to cart (hero button + sticky bar button both use [data-add-to-cart])
    document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!state.variantId) return;
        btn.disabled = true;
        var originalHtml = btn.innerHTML;
        addToCart(state.variantId, 1)
          .then(function () {
            trackAddToCart(state);
            window.location.href = '/cart';
          })

          .catch(function (err) {
            console.error('SPIRO+ theme: add to cart failed', err);
            alert('Could not add to cart: ' + err.message);
          })
          .finally(function () {
            btn.disabled = false;
            btn.innerHTML = originalHtml;
          });
      });
    });

    refreshCartCount();
  });
})();
